import { TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '@Scatt';

class LabelForCefrData extends TimelineSegmentContentDataBase {
  constructor(label = '', topic = '') {
    super();
    this.label = label;
    this.topic = topic;
  }

  static generateFromRawObj(labelDataRawObj) {
    return new this(labelDataRawObj['label'], labelDataRawObj['topic']);
  }

  generateRawObj() {
    let labelDataRawObj = {};
    labelDataRawObj['label'] = this.label;
    labelDataRawObj['topic'] = this.topic;
    return labelDataRawObj;
  }

  toString() {
    return this.label;
  }

  clone() {
    return new this.constructor(this.label, this.topic);
  }

  isSameAs(that) {
    if (this.label !== that.label) return false;
    if (this.topic !== that.topic) return false;
    return true;
  }

  combine(that) {
    if (this.label.length === 0) {
      if (that.label.length > 0) this.label = that.label;
    } else {
      if (that.label.length > 0) this.label = `${this.label} ${that.label}`;
    }
    if (this.topic.length === 0) {
      if (that.topic.length > 0) this.topic = that.topic;
    }
  }
}

class LabelForCefrSegmentData extends TimelineSegmentDataBase {
  static contentData = LabelForCefrData;

  constructor(begin, end, labelData, isLocked) {
    super(begin, end, labelData, isLocked);
  }

  static toString() {
    return 'LabelForCefrSegmentData';
  }

  static get name() {
    return 'Label Data For CEFR';
  }

  clone() {
    return super.clone(false);
  }
}

export default LabelForCefrSegmentData;
